import { render, staticRenderFns } from "./EditDatingPreferencePage.vue?vue&type=template&id=6964164c&scoped=true"
import script from "./EditDatingPreferencePage.vue?vue&type=script&lang=js"
export * from "./EditDatingPreferencePage.vue?vue&type=script&lang=js"
import style0 from "./EditDatingPreferencePage.vue?vue&type=style&index=0&id=6964164c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964164c",
  null
  
)

export default component.exports